module.exports = __webpack_public_path__ + "static/media/Getidan.88e971f1.PNG";